import { useState } from "react"

import { TODAY_CATEGORIES, type TodayCategory } from "../config/categories"
import { TodayNavigation } from "./today-navigation"
import { HoroscopeCategory } from "./horoscope/horoscope-category"
import { NumerologyCategory } from "./numerology/numerology-category"
import { TarotCategory } from "./tarot/tarot-category"
import { RunesCategory } from "./runes/runes-category"
import { BiorhythmCategory } from "./biorhythm/biorhythm-category"
import { MoonCategory } from "./moon/moon-category"
import { ReportsCategory } from "./reports/reports-category"

/** Today hub (`/webapp/today`): category tab bar + the selected category's content. */
export function TodayPage() {
  const [selected, setSelected] = useState<TodayCategory>(TODAY_CATEGORIES.HOROSCOPE)

  return (
    <div className="-mx-4 bg-dark-base pb-10">
      <TodayNavigation selected={selected} onSelect={setSelected} />
      <TodayContent category={selected} />
    </div>
  )
}

function TodayContent({ category }: { category: TodayCategory }) {
  switch (category) {
    case TODAY_CATEGORIES.HOROSCOPE:
      return <HoroscopeCategory />
    case TODAY_CATEGORIES.NUMEROLOGY:
      return <NumerologyCategory />
    case TODAY_CATEGORIES.TAROT:
      return <TarotCategory />
    case TODAY_CATEGORIES.RUNES:
      return <RunesCategory />
    case TODAY_CATEGORIES.BIORHYTHM:
      return <BiorhythmCategory />
    case TODAY_CATEGORIES.MOON:
      return <MoonCategory />
    case TODAY_CATEGORIES.REPORTS:
      return <ReportsCategory />
    default:
      return (
        <div className="flex min-h-[50dvh] flex-col items-center justify-center gap-2 text-center">
          <p className="font-display text-2xl font-medium text-purple-light">Coming soon</p>
          <p className="font-body text-sm text-purple-light/60">This section is being prepared</p>
        </div>
      )
  }
}
